import React from "react";
import { useState } from "react";
import { InstitutosSelect } from "../components/shared/institutos-select";
import useObtenerSubsecciones from "../js/translations/useObtenerSubsecciones";
import PropTypes from "prop-types";

/**
 * Este se encarga de renderizar la sección ¿tu institucion ya tiene MakeMake? en el login. Este recibe como parametro una función que se encarga de validar el campo del select y redireccionar a la pantalla correspondiente. 
 * @returns InstitucionesForm
 */
export const InstitucionesForm = ({ onSubmit }) => {
    const {textosSubSecciones:textos} = useObtenerSubsecciones('login');
    const [institucionSeleccionado, setInstitucionSeleccionada] = useState('');

    const onSubmitHandler = ()=>{
        onSubmit&&onSubmit(institucionSeleccionado);
    }
    return (
        <>
            <div className="row mx-0 pt-3 pb-4">
                <h2 className="secondary-item">{textos?.titulos?.institucion_tiene_makemake || '¿tu institución ya tiene MakeMake?'}</h2>
                <form className='w-100 row mx-0 pt-3 justify-content-center align-items-center' onSubmit={(e) => e.preventDefault()}>
                    <label className='m-1 col-md-8 p-0' title='Selector de institutos' aria-label='selector de institutos'>
                        <InstitutosSelect onChange={(institucion) => setInstitucionSeleccionada(institucion)} />
                    </label>
                    <button 
                        className="m-1 col-md-3 btn btn-primary focusable-red" 
                        onClick={()=>onSubmitHandler()} 
                    >{textos?.login?.botones?.continuar || 'Continuar'}</button>
                </form>
            </div>
        </>
    )
}

InstitucionesForm.propTypes = {
    /**
  * Función que recibe la opción seleccionada y redirecciona al formulario correspondiente. 
  * @type{Function(institucion:string):void} -callback
  */
    onSubmit: PropTypes.func.isRequired
} 